export default __webpack_public_path__ + "static/media/events.a1b9f246.jpg";